<template>
	<div>
		<template v-if="colType=='show'">
			<template v-if="name=='$switch'">
				<el-switch v-model="row[column.property]" :disabled="prop.disabled"></el-switch>
			</template>
			<template>
				{{row[column.property]}}
			</template>
		</template>
		<template v-if="colType=='edit'">
			<el-switch v-model="row[column.property]" :disabled="prop.disabled" v-if="name=='$switch'"></el-switch>
			<!-- <dropTable :value="row[column.property]" :tableData4="prop.data" 
				:tableColumn4="droptableHead" :valuename="prop.valuename" 
				:filtervalue="prop.filtername" @onclick="row[column.property]=$event" v-else-if="name=='MydropTable'"></dropTable> -->
			<!-- <div v-else-if="name=='MydropTable'">{{row[column.property]}}</div>	 -->
			<el-select v-model="row[column.property]" class="widtfull" v-else-if="name=='MydropTable'" :disabled="prop['disabled']">
				<el-option v-for="(i,x) in dropDATAFilter" :key="x" :value="i[prop['valueName']]"
					:label="i[prop['displayName']]">
					<template v-if="prop['itemBoth']">
						<span key="-1" style="float: left;margin-right: .8rem;">{{i[prop['valueName']]}}</span>
						<span key="-2" style="float: right; color: #8492a6;">{{i[prop['displayName']]}}</span>
					</template>	
				</el-option>
			</el-select>
			
			<el-date-picker v-model="row[column.property]"  style="width: 100%;" 
				:value-format="prop.format" class="widtfull" :type="prop.type" placeholder="日期选择" :disabled="prop['disabled']"  v-else-if="name=='$datetime'">
			</el-date-picker>
			<el-input v-model="row[column.property]" :type="prop.type" @blur="$emit('blur')"  :min="prop.min" :disabled="prop['disabled']" @mousewheel.native="input_wheel"  v-else></el-input>
		</template>
	</div>
</template>

<script>
	// import dropTable from './droptable.vue'
	export default {
		props: {
			row: {
				type: Object,
				default: ()=>{}
			},
			column: {
				type: Object,
				default: ()=>{}
			},
			name: {
				type: String,
				default: ''
			},
			colType: {
				type: String,
				default: 'show'
			},
			prop: {
				type: Object,
				default: ()=>{}
			},
			event: {
				type: Object,
				default: ()=>{}
			}
		},
		computed:{
			droptableHead(){
				let cols=[];
				if(this.prop.data&&this.prop.data.length>0){
						for (let i in this.prop.data[0]) {
							cols.push({
								field: i,
								title: i
							})
						}
				}
				return cols;
			},
			dropDATAFilter(){
				if(this.prop['filtername']){
					return this.prop.data.filter(item=>{
						return this.row[this.prop['filtername']]==item['filterCol'];
					})
				}
				return this.prop.data;
			}
		},
		methods:{
			input_wheel(e){
				if(this.prop.type=='number'&&(this.column.property=='包装数量'||this.column.property=='本次打印数量')){
					e=e||window.event;
					e.preventDefault()
				}
			}
			// CHANGROW(){
			// 	this
			// }
		},
		mounted(){
			// console.log(this.prop.data)
			// console.log(this.name,this.prop)
		}
		// components:{dropTable}
	}
</script>

<style>
</style>
